<script>

export default {
    props: {
        messages: {
            required: true,
            type: Object
        }
    },
}
</script>
<template>
    
    <div>
        <ul class="mb-2" v-for="(message, key) in messages">
            <div>
                <span v-if="typeof key === 'string'" class="text-bold">{{ key }}:</span>
            </div>
            <div v-if="Array.isArray(message)">
                <ul v-for="content in message">
                    <li :class="{'bg-yellow': typeof content === 'string' && content.includes('successfully') ? false : true}">
                        {{ content }}
                    </li>
                </ul>
            </div>
            <div v-else-if="typeof message === 'object'">
                <div v-for="content in message">
                    
                    <div v-if="Array.isArray(content)">
                        <ul v-for="validationError in content" >
                            <li class="bg-yellow">
                                {{ validationError }}
                            </li>
                        </ul>
                    </div>
                    <div v-else :class="{'bg-yellow': typeof content === 'string' && content.includes('successfully') ? false : true}">
                        {{ content }}
                    </div>
                </div>
            </div>
            <div v-else :class="{'bg-yellow': typeof message === 'string' && message.includes('successfully') ? false : true}">
                <li>
                    {{ message }}
                </li>
            </div>
        </ul>
    </div>
</template>
